import { DtPrefs, DtPrefs3D, DtPrefsHelper } from './DtPreferenceNames';

import { av } from "@adsk/lmv";
const { isMobileDevice, Profile, ProfileSettings } = av;

export const DEFAULT_STORAGE_PREFIX = 'Autodesk.Tandem.Preferences.';

// We're extending the default profile here. Fluent would be closer to Tandem,
// but it's a copy of a copy of the default, so there's more potential for silent divergence.
// Note that 2d settings are ignored, because we don't use them in Tandem.
const defaultProfile = ProfileSettings.Default;
export const TandemSettings = ProfileSettings.clone(defaultProfile);
TandemSettings.name = 'Tandem';
TandemSettings.label = 'Tandem';
TandemSettings.description = 'A common set of preferences for Autodesk Tandem';

// Tandem-added preferences
TandemSettings.settings[DtPrefs.ENABLE_MODEL_CACHE] = true;
TandemSettings.settings[DtPrefs.DISPLAY_OBJECT_INFO] = false;

// Preferences that differ from LMV's default profile values
TandemSettings.settings[DtPrefs.FUSION_ORBIT] = false;
TandemSettings.settings[DtPrefs.FUSION_ORBIT_CONSTRAINED] = false;
TandemSettings.settings[DtPrefs.OPEN_PROPERTIES_ON_SELECT] = true;
TandemSettings.settings[DtPrefs.RESTORE_SESSION_MEASUREMENTS] = false;
TandemSettings.settings[DtPrefs.REVERSE_MOUSE_ZOOM_DIR] = true;
TandemSettings.settings[DtPrefs.WHEEL_SETS_PIVOT] = true;
TandemSettings.settings[DtPrefs.WEBGPU] = true; // TODO-LMV: Remove once it's the default in LMV

TandemSettings.settings[DtPrefs3D.ALWAYS_USE_PIVOT] = true;
TandemSettings.settings[DtPrefs3D.DISPLAY_SECTION_HATCHES] = true;
TandemSettings.settings[DtPrefs3D.ENABLE_CUSTOM_ORBIT_TOOL_CURSOR] = false;
TandemSettings.settings[DtPrefs3D.EDGE_RENDERING] = !isMobileDevice();
TandemSettings.settings[DtPrefs3D.GROUND_SHADOW] = false;
TandemSettings.settings[DtPrefs3D.LIGHT_PRESET] = "Boardwalk";
TandemSettings.settings[DtPrefs3D.SELECTION_SETS_PIVOT] = true;
TandemSettings.settings[DtPrefs3D.VIEW_CUBE_COMPASS] = true;

// We want to persist all settings for Tandem.
// LMV defines a list of settings that get persisted globally (independent of the profile),
// so we have to remove those from the list.
TandemSettings.persistent = [];
for (const prefName of DtPrefsHelper.prefNames) {
  if (defaultProfile.sharedStorage.includes(prefName)) {
    continue;
  }

  TandemSettings.persistent.push(prefName);
}

// Extend LMV's profile class
export class DtProfile extends Profile {
  constructor(profileSettings) {
    super(profileSettings);

    // We cannot simply override the apply method, because LMV does not define it on the prototype,
    // but as an instance member in the constructor. So we need to do the same here.
    this.superApply = this.apply;
    this.apply = function (prefs, override) {
      this.superApply(prefs, override);

      for (const setting in this.settings) {
        // LMV sets an 'ignore-producer' tag on preferences that come from external profiles.
        // This tag locks certain settings, so we don't want it and need to remove it again.
        prefs.untag('ignore-producer', setting);

        // If we ever add custom 2d/3d preferences, add the corresponding tags here.
      }
    };
  }
}

// The Tandem profile instance
export const TandemProfile = new DtProfile(TandemSettings);